import type {
  ProductCategory,
  ProductKind,
  ProductType,
} from '@iheartjane/types';

import { defaultProductPhotoUrl } from './getProductImages';

export interface ProductPhotoMetaData {
  category?: ProductCategory | null;
  image_urls?: string[] | readonly string[];
  kind?: ProductKind | null;
  root_subtype?: string | null;
  type?: ProductType | null;
}

export const productPhotoMetadata = (
  productInfo?: ProductPhotoMetaData
): { photoSource: 'jane' | 'default'; url: string } => {
  if (!productInfo) {
    return { photoSource: 'jane', url: '' };
  }

  const { category, image_urls, kind, root_subtype, type } = productInfo;

  let photoSource: 'jane' | 'default' = 'jane';
  let url: string = '';

  if (image_urls?.length) {
    url = image_urls[0];
  } else if (kind) {
    url = defaultProductPhotoUrl({
      category,
      kind,
      productRootSubtype: root_subtype,
      productType: type,
    });
    photoSource = 'default';
  }

  return {
    photoSource,
    url,
  };
};
